import { render, staticRenderFns } from "./PrazoEntregaRegioesEstado.vue?vue&type=template&id=20918589"
import script from "./PrazoEntregaRegioesEstado.vue?vue&type=script&lang=js"
export * from "./PrazoEntregaRegioesEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports